module.exports = __webpack_public_path__ + "static/a-tale-of-two-olympic-victories-027b7fb48f94a32d584480ae87e92e11.jpg";